module.exports = __webpack_public_path__ + "static/waltz-krem-rolls-mlecni-b82a7743046fa33faf260156e0b0ccf3.jpg";